export default "__VITE_ASSET__DugbdbLI__"